import '@stimulus/polyfills'
import '../src/utils/localStorage_protection'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import Chart from 'stimulus-chartjs'
// 訪問者属性調査バナー（Issue #12990）。siteエントリポイントでは require.context のルートが
// components/site のため自動導出される識別子が異なる。全entrypointで識別子を揃えるため明示登録する。
import VisitorSurveyController from '../../components/site/parts/visitor_survey/desktop/component_controller'

function importAll (r) {
  r.keys().forEach(r)
}
importAll(require.context('../../components/site', true, /desktop\/component\.(js|ts)$/))
importAll(require.context('../../components/site', true, /common\/component\.(js|ts)$/))
importAll(require.context('../../components/site/common', true, /component\.(js|ts)$/))
importAll(require.context('../src/common', true, /.*\.(js|ts)$/))

const application = Application.start()
application.register('chart', Chart)
application.register('visitor-survey--desktop--component', VisitorSurveyController)
application.load(definitionsFromContext(require.context('../../components/site', true, /desktop\/component_controller\.(js|ts)$/)))
application.load(definitionsFromContext(require.context('../../components/site', true, /common\/component_controller\.(js|ts)$/)))
application.load(definitionsFromContext(require.context('../../components/site/common', true, /component_controller\.(js|ts)$/)))

const images = require.context('../images', true)
export { images }
